import React, { useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { setUserGroup, useMaterialUIController } from "../../context";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { useNavigate } from "react-router-dom";
import { useUserDetails } from "../../context/auth";
import NoAccessPage from "../AccessDenied";
import {AutoLogin} from '../../Redux/action/quizAction'
import { useDispatch, useSelector } from "react-redux";
import { encryptData } from "../../layoutcontainers/DashboardLayout/components/Navbar/Encripted";

const SECRET_KEY = "1234"; // same in App A

const AuthLoader = ({
  text = "HRMS",
  colorGradient = ["#0B1D51", "#0b1d51b3", "#0B1D51", "#0b1d51b3"], // gradient colors
  size = 48,
  background = "rgba(255,255,255,0.95)",
  duration = 2,
  gap = 8,
  barWidth = 240,
}) => {
  const letters = Array.from(text);
  const navigate = useNavigate();
  const reduxcall = useDispatch()
  const { updatingUser } = useUserDetails();
  const [controller, dispatch] = useMaterialUIController();
  const autologindata = useSelector((state) => state.quiz.autologindata);
    console.log("autologindata=>",autologindata)

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
    animation:false
    });
    
  const [user, setUser] = useState({
    name: "",
    userName: "",
    email: "",
    picture: "",
    token: "",
    details: "",
  });

  // Inject keyframes once
  React.useEffect(() => {
    const styleSheet = document.styleSheets[0];

    const keyframes = [
      `@keyframes hf-flip {
        0% { transform: perspective(400px) rotateX(0deg) translateY(0); opacity: 1; }
        28% { transform: perspective(400px) rotateX(12deg) translateY(-6%); opacity: 0.95; }
        50% { transform: perspective(400px) rotateX(180deg) translateY(-34%); opacity: 0.5; }
        72% { transform: perspective(400px) rotateX(10deg) translateY(-4%); opacity: 0.95; }
        100% { transform: perspective(400px) rotateX(0deg) translateY(0); opacity: 1; }
      }`,
      `@keyframes hf-message-pulse {
        0% { transform: translateY(0); opacity: 0.9; }
        50% { transform: translateY(-4px); opacity: 1; }
        100% { transform: translateY(0); opacity: 0.9; }
      }`,
      `@keyframes gradient-shift {
        0% { background-position: 0% 50%; }
        100% { background-position: 200% 50%; }
      }`,
    ];

    keyframes.forEach((rule) => {
      if (![...styleSheet.cssRules].some((r) => r.cssText.includes(rule))) {
        styleSheet.insertRule(rule, styleSheet.cssRules.length);
      }
    });
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    
    const encryptedData = params.get("data");

    sessionStorage.setItem("encryptData", encryptedData);
    if (encryptedData) {
      try {
        reduxcall(AutoLogin(encryptedData))
        const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
        const creds = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        // Auto-login using creds directly (avoid async state delay)
        handleSignIn(creds.email, creds.password);
      } catch (err) {
        console.error("Decryption failed:", err);
      }
    }
  }, []);

  const handleSignIn = async (emailParam, passwordParam) => {
    const LOGIN = gql`
      mutation User_Login($email: String!, $password: String!) {
        userLogin(email: $email, password: $password) {
          detail
          access
          message
          success
          error
        }
      }
    `;

    setPageState({
      ...pageState,
      loading: true,
    });

    try {
      const response = await request(BASEURL, LOGIN, {
        email: emailParam,
        password: passwordParam,
      });
      
      if (response.userLogin.success) {
        sessionStorage.setItem("is_auth", JSON.stringify("true"));
        sessionStorage.setItem(
          "user",
          JSON.stringify(response.userLogin.detail)
        );
        sessionStorage.setItem(
          "access",
          JSON.stringify(response.userLogin.access)
        );
        localStorage.setItem("rememberedEmail", encryptData(emailParam));
        localStorage.setItem(
          "rememberedPassword",
          encryptData(passwordParam)
        );

        setUserGroup(dispatch, response.userLogin);

        setUser({
          ...user,
          name:
            response.userLogin.detail.firstName +
            " " +
            response.userLogin.detail.lastName,
          userName: response.userLogin.detail.username,
          email: response.userLogin.detail.email,
          details: response.userLogin.detail,
        });
        updatingUser();
        setTimeout(() => {
          navigate("/dashboard");
        }, 2000);
        console.log("run success:", response.userLogin.success);
      } else {
        sessionStorage.setItem("token", "undefined");
        sessionStorage.setItem("user", "undefined");
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          title: "Error message",
          message: response?.userLogin?.message,
          state: "default",
          animation:true
        });
      }
    } catch (error) {
      console.log("error:", error);
      sessionStorage.setItem("token", "undefined");
      sessionStorage.setItem("user", "undefined");
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        title: "Error message",
        message: "An error occurred. Please try again.",
        state: "default",
        animation:true
      });
    }
  };

  const gradientCSS = `linear-gradient(120deg, ${colorGradient.join(", ")})`;

  return (
    pageState.animation?
    <NoAccessPage/>
    :
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
        background,
        backdropFilter: "blur(6px)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          padding: "20px 28px",
          borderRadius: "12px",
        }}
      >
        {/* Letters with gradient */}
        <div style={{ display: "inline-flex", gap: `${gap}px` }}>
          {letters.map((ch, idx) => {
            const delay = (idx * 0.12).toFixed(2);
            return (
              <span
                key={idx}
                style={{
                  display: "inline-block",
                  fontWeight: 700,
                  fontSize: `${size}px`,
                  lineHeight: 1,
                  textTransform: "uppercase",
                  backgroundImage: gradientCSS,
                  backgroundSize: "200% 200%",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                  animation: `
                    hf-flip ${duration}s cubic-bezier(.2,.9,.2,1) infinite,
                    gradient-shift 3s linear infinite
                  `,
                  animationDelay: `${delay}s, 0s`,
                }}
              >
                {ch === " " ? "\u00A0" : ch}
              </span>
            );
          })}
        </div>

        {/* Slow-moving gradient loader line */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: `${barWidth}px`,
              height: "8px",
              borderRadius: "999px",
              backgroundImage: gradientCSS,
              backgroundSize: "300% 100%",
              animation: "gradient-shift 6s ease-in-out infinite",
              marginBottom: "8px",
            }}
          />
          <div
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: "rgba(0,0,0,0.6)",
              animation: "hf-message-pulse 1.6s ease-in-out infinite",
            }}
          >
            Securing your workspace…
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLoader;
